module.exports = __webpack_public_path__ + "img/500.990ae4d0.svg";